import React from "react";
import {
  Box,
  Container,
  Heading,
  Text,
  VStack,
  Icon,
  Grid,
  GridItem,
  Circle,
  Image,
} from "@chakra-ui/react";

const ServicesGrid = ({
  title,
  highlightText,
  description,
  services,
  containerMaxW = "7xl",
  gridMaxW = "5xl"
}) => {
  return (
    <Box w="full" pb={8} pt={8}>
      <Container maxW={containerMaxW} px={0}>
        <VStack spacing={(title || description) ? 8 : 0} align="start">
          {/* Conditionally render header section only if title or description exists */}
          {(title || description) && (
            <VStack spacing={4} align="start">
              {title && (
                <Heading
                  fontSize={{ base: "2xl", md: "3xl" }}
                  fontWeight="bold"
                  color="gray.800"
                >
                  {title} {highlightText && <Text as="span" color="#000B8C">{highlightText}</Text>}
                </Heading>
              )}
              {description && (
                <Text
                  fontSize={{ base: "md", md: "lg" }}
                  color="gray.600"
                  maxW="4xl"
                >
                  {description}
                </Text>
              )}
            </VStack>
          )}

          {/* Grid of Services - 2 rows, 3 columns */}
          <Grid
            templateColumns={{ base: "1fr", md: "repeat(3, 1fr)" }}
            gap={0}
            maxW={gridMaxW}
            w="full"
            mx="auto"
          >
            {services.map((service) => (
              <GridItem key={service.id}>
                <Box
                  p={6}
                  h="full"
                  borderRight={{
                    base: "none",
                    md: service.isRightmost ? "none" : "1px solid"
                  }}
                  borderRightColor="#000B8C"
                  borderBottom={service.isTopRow ? "1px solid" : "none"}
                  borderBottomColor="#000B8C"
                  display="flex"
                  flexDirection="column"
                  minH="220px"
                >
                  <VStack align="center" spacing={6} textAlign="center" flex="1" justify="center">
                    <Circle size="60px" bg="blue.50" color="#000B8C" flexShrink={0}>
                      <Image
                        src={service.icon}
                        alt={service.title}
                        // w={12}
                        // h={12}
                        className="service-icon"
                        transition="all 0.3s ease"
                      />
                    </Circle>
                    
                    <VStack spacing={3} flex="1" justify="center">
                      <Heading 
                        size="md" 
                        color="gray.800" 
                        fontWeight="bold"
                        minH="48px"
                        display="flex"
                        alignItems="center"
                        textAlign="center"
                      >
                        {service.title}
                      </Heading>
                      <Text 
                        color="gray.600" 
                        fontSize="sm" 
                        lineHeight="1.6"
                        textAlign="center"
                        maxW="280px"
                      >
                        {service.description}
                      </Text>
                    </VStack>
                  </VStack>
                </Box>
              </GridItem>
            ))}
          </Grid>
        </VStack>
      </Container>
    </Box>
  );
};

export default ServicesGrid;